import React from "react";
import About from "../components/About";

const PageAbout = () => {
  return (
    <div className="bg-gray-100 h-auto pt-16 w-auto">
      <About />
    </div>
  );
};

export default PageAbout;
